(function () {
  if (window.matchMedia('(min-width: 1000px)').matches) return;

  function findInlineAtc() {
    return (
      document.querySelector('product-form button[type="submit"]') ||
      document.querySelector('button[name="add"]') ||
      document.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
      document.querySelector('buy-buttons button[type="submit"]')
    );
  }
  function findVariantPicker() {
    return document.querySelector('variant-picker, .variant-picker');
  }
  function findPriceDisplay() {
    return document.querySelector(
      '.price-item--sale, .price__current, .price-item, [class*="price-item"]'
    );
  }

  function init() {
    var btn = document.getElementById('sbStickyAtcBtn');
    if (!btn) return;
    var labelEl = document.getElementById('sbStickyAtcLabel');
    var priceEl = document.getElementById('sbStickyAtcPrice');

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var current = findInlineAtc();
      if (current && !current.disabled) {
        current.click();
      } else {
        var picker = findVariantPicker();
        if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    var tries = 0;
    function trySync() {
      var inline = findInlineAtc();
      if (inline) {
        var t = inline.textContent.trim();
        if (t && labelEl) labelEl.textContent = t;
        var p = findPriceDisplay();
        if (p && priceEl) priceEl.textContent = p.textContent.trim();
      } else if (tries++ < 10) {
        setTimeout(trySync, 200);
      }
    }
    trySync();

    document.addEventListener(
      'variant:change',
      function () {
        setTimeout(trySync, 80);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
